import React from 'react';

export default function CustomInfoWindow(props) {
  return (
    <div className="card" style={{ width: '200px', position: 'relative' }}>
      {props.onCloseClick && (
        <button
          onClick={props.onCloseClick}
          style={{
            position: 'absolute',
            top: '4px',
            right: '4px',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: '16px',
            lineHeight: 1,
            padding: '0 4px',
          }}
          aria-label="Close"
        >
          &times;
        </button>
      )}
      {props.children}
    </div>
  );
}

export const getInfoWindow = (props, inner) => {
  return (
    <CustomInfoWindow
      position={props.OverridePosition || props.Position || props.Positions.offsite}
      options={{ pixelOffset: { height: '-3' } }}
      onCloseClick={props.onCloseClick}
    >
      {inner}
    </CustomInfoWindow>
  );
};
